module.exports = __webpack_public_path__ + "static/img/cocina_07.7f955a8c.jpeg";